import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

document.addEventListener('DOMContentLoaded', function () {
  // .sticky-active CLASS ON SCROLL
  const primaryHeader = document.querySelector("header");
  const scrollWatcher = document.createElement("div");

  scrollWatcher.setAttribute("data-scroll-watcher", "");
  primaryHeader.before(scrollWatcher);

  const navObserver = new IntersectionObserver(
    (entries) => {
      primaryHeader.classList.toggle("sticky-active", !entries[0].isIntersecting);
    },
    { rootMargin: "50px 0px 0px 0px" }
  );
  navObserver.observe(scrollWatcher);

  // NAVIGATION
  const nav = document.getElementById('site-navigation');
  const toggle = nav.querySelector('.menu-toggle');
  const closenav = document.querySelector('.nav-close');
  const menu = document.querySelector('.site-nav');
  const focusableSelectors = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function trapFocus(container) {
    const focusables = container.querySelectorAll(focusableSelectors);
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    function handleTrap(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      if (e.key === 'Escape') {
        closeMenu();
      }
    }

    container.addEventListener('keydown', handleTrap);
    return () => container.removeEventListener('keydown', handleTrap);
  }

  let releaseFocus = null;

  function openMenu() {
    nav.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    releaseFocus = trapFocus(menu);
    setTimeout(() => {
      const firstLink = menu.querySelector(focusableSelectors);
      if (firstLink) firstLink.focus();
    }, 100);
  }

  function closeMenu() {
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    if (releaseFocus) releaseFocus();
    toggle.focus();
  }

  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  closenav.addEventListener('click', () => {
    console.log('closebtn');
      closeMenu();
  });

  // Ferme si on clique en dehors du menu
  document.addEventListener('click', (e) => {
    if (
      nav.classList.contains('is-open') &&
      !nav.contains(e.target)
    ) {
      closeMenu();
    }
  });

  // DROPDOWN PERSONAS DANS LA NAV PRINCIPALE
  const toggleBtn = document.querySelector('.dropdown-toggle');
  const dropdown = document.querySelector('.dropdown');

  toggleBtn.addEventListener('click', (event) => {
    event.stopPropagation();
    const isOpen = dropdown.getAttribute('data-open') === 'true';
    dropdown.setAttribute('data-open', !isOpen);
    toggleBtn.setAttribute('aria-expanded', !isOpen);
  });

  document.addEventListener('click', (event) => {
    const isClickInside = dropdown.contains(event.target);
    if (!isClickInside) {
      dropdown.setAttribute('data-open', 'false');
      toggleBtn.setAttribute('aria-expanded', 'false');
    }
  });

  // HOME PROJETS
  const infosItems = document.querySelectorAll('.projets__infos--item a');
  const images = document.querySelectorAll('.projets__image figure');

  function activateImage(index) {
      images.forEach((img, i) => {
          img.classList.toggle('active', i == index);
      });
  }

  infosItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
          activateImage(item.dataset.index);
      });

      item.addEventListener('focus', () => {
          activateImage(item.dataset.index);
      });

      item.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
              activateImage(item.dataset.index);
              e.preventDefault();
          }
      });
  });

  // SIDEBAR DE NAVIGATION
  if (document.body.classList.contains('page-template-page-sidebar')) {
    const section = document.querySelector('.editor');
    const headingsH2 = section.querySelectorAll('h2');
    const headingsH3 = section.querySelectorAll('h3, .wp-block-columns .wp-block-column h3');
    const aside = document.querySelector('aside');

    // Ajouter des identifiants uniques aux titres H2 et H3
    headingsH2.forEach((h2, index) => {
      const safeText = h2.textContent.replace(/\s+/g, '-').toLowerCase();
      h2.id = `h2-${safeText}-${index}`;
    });

    headingsH3.forEach((h3, index) => {
      const safeText = h3.textContent.replace(/\s+/g, '-').toLowerCase();
      h3.id = `h3-${safeText}-${index}`;
    });

    // Construire le menu HTML avec des liens
    let menuHtml = '<p id="sommaire">Sommaire</p><ul class="menu-h2">';
    headingsH2.forEach(h2 => {
      menuHtml += `<li><a href="#${h2.id}">${h2.textContent}</a>`;
      let nextElement = h2.nextElementSibling;
      let h3Items = [];

      while (nextElement && nextElement.tagName !== 'H2') {
        if (nextElement.matches('.wp-block-columns, .wp-block-column')) {
          const nestedH3s = nextElement.querySelectorAll('h3');
          nestedH3s.forEach(nestedH3 => {
            const nestedSafeText = nestedH3.textContent.replace(/\s+/g, '-').toLowerCase();
            nestedH3.id = `h3-${nestedSafeText}`;
            h3Items.push(nestedH3);
          });
        } else if ( (nextElement.tagName === 'H3') ) {
          h3Items.push(nextElement);
        }

        nextElement = nextElement.nextElementSibling;
      }

      if (h3Items.length > 0) {
        menuHtml += '<ul class="menu-h3">';
        h3Items.forEach(h3 => {
          menuHtml += `<li><a href="#${h3.id}">${h3.textContent}</a></li>`;
        });
        menuHtml += '</ul>';
      }

      menuHtml += '</li>';
    });
    menuHtml += '</ul>';
    aside.innerHTML = menuHtml;

    let currentActive = null;  // Garder une trace de l'élément actif actuel

    // Sélectionner et activer par défaut le premier H2 de la navigation
    const firstH2Link = aside.querySelector('li a');
    if (firstH2Link) {
      firstH2Link.parentElement.classList.add('active');
      currentActive = document.getElementById(firstH2Link.getAttribute('href').substring(1));
    }

    // Fonction pour ajouter ou retirer la classe active
    function setActiveHeading() {
      const activationCenter = window.innerHeight * 0.15;
      const activationHeight = window.innerHeight * 0.2; // 20% height

      const headings = [...section.querySelectorAll('h2'), ...section.querySelectorAll('h3')];
      let newActiveHeading = null;

      headings.forEach(heading => {
        const rect = heading.getBoundingClientRect();
        if (rect.top <= activationCenter + activationHeight / 2 && rect.bottom >= activationCenter - activationHeight / 2) {
          if (!newActiveHeading || Math.abs(activationCenter - (rect.top + rect.height / 2)) < Math.abs(activationCenter - (newActiveHeading.getBoundingClientRect().top + newActiveHeading.getBoundingClientRect().height / 2))) {
            newActiveHeading = heading;  // Nouveau titre le plus proche du centre
          }
        }
      });

      // Mise à jour conditionnelle de la classe active
      if (newActiveHeading && (!currentActive || currentActive.textContent !== newActiveHeading.textContent)) {
        aside.querySelectorAll('li a').forEach(a => {
          a.parentElement.classList.remove('active');
        });
        const activeItem = aside.querySelector(`a[href="#${newActiveHeading.id}"]`);
        if (activeItem) {
          activeItem.parentElement.classList.add('active');
          currentActive = newActiveHeading;
        }
      }
    }

    // Ajouter l'écouteur d'événement sur scroll
    document.addEventListener('scroll', setActiveHeading);

    function transformMenuToCustomDropdown() {
      if (window.innerWidth > 992) return;

      const ul = aside.querySelector('ul.menu-h2');
      if (!ul) return;

      const dropdownWrapper = document.createElement('div');
      dropdownWrapper.className = 'summary-dropdown';

      const toggleButton = document.createElement('button');
      toggleButton.className = 'summary-toggle';
      toggleButton.setAttribute('aria-expanded', 'false');
      toggleButton.setAttribute('aria-controls', 'summary-menu');
      toggleButton.id = 'sommaire';
      toggleButton.textContent = 'Sommaire';

      document.addEventListener('click', function (event) {
        const isClickInside = dropdownWrapper.contains(event.target);
        if (!isClickInside) {
          toggleButton.setAttribute('aria-expanded', 'false');
          dropdownList.hidden = true;
        }
      });

      const dropdownList = document.createElement('ul');
      dropdownList.className = 'summary-menu';
      dropdownList.hidden = true;

      ul.querySelectorAll(':scope > li').forEach(li => {
        const link = li.querySelector(':scope > a');
        if (link) {
          const liItem = document.createElement('li');
          const aItem = document.createElement('a');
          aItem.href = link.getAttribute('href');
          aItem.textContent = link.textContent;
          liItem.appendChild(aItem);
          dropdownList.appendChild(liItem);

          const subUl = li.querySelector('ul.menu-h3');
          if (subUl) {
            subUl.querySelectorAll('a').forEach(subLink => {
              const subLi = document.createElement('li');
              subLi.className = 'submenu';
              const subA = document.createElement('a');
              subA.href = subLink.getAttribute('href');
              subA.textContent = '— ' + subLink.textContent;
              subLi.appendChild(subA);
              dropdownList.appendChild(subLi);
            });
          }
        }
      });

      toggleButton.addEventListener('click', () => {
        const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
        toggleButton.setAttribute('aria-expanded', String(!isExpanded));
        dropdownList.hidden = isExpanded;
      });

      dropdownList.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => {
          toggleButton.setAttribute('aria-expanded', 'false');
          dropdownList.hidden = true;
        });
      });

      // Nettoyage
      aside.innerHTML = '';
      dropdownWrapper.appendChild(toggleButton);
      dropdownWrapper.appendChild(dropdownList);
      aside.appendChild(dropdownWrapper);
    }

    transformMenuToCustomDropdown();

    let currentView = window.innerWidth <= 992 ? 'dropdown' : 'list';

    function rebuildMenu() {
      if (window.innerWidth <= 992 && currentView !== 'dropdown') {
        transformMenuToCustomDropdown();
        currentView = 'dropdown';
      } else if (window.innerWidth > 992 && currentView !== 'list') {
        location.reload(); // regénérer le menu initial pour éviter reload
        currentView = 'list';
      }
    }

    window.addEventListener('resize', () => {
      clearTimeout(window.__resizeTimeout);
      window.__resizeTimeout = setTimeout(rebuildMenu, 200); // anti-rebond
    });
  }

  // Navigation hub // bloc page enfant
  const childpages = document.querySelector('.child-pages')
  if (document.body.classList.contains('page-template-page-hub') || childpages) {
    document.querySelectorAll('.menu-toggle').forEach(toggle => {
      toggle.addEventListener('click', event => {
        event.preventDefault();

        const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute('aria-expanded', !isExpanded);
        submenu.hidden = isExpanded;
        submenu.setAttribute('data-visible', !isExpanded);
      });
    });
  }

  // MODALE DE RECHERCHE 
  const openBtns = document.querySelectorAll('[data-open-search]');
  const closeBtn = document.querySelector('[data-close-search]');
  const modal = document.getElementById('search-modal');
  const input = document.getElementById('search-field');
  const modalFocusableSelectors = 'input, button, [tabindex]:not([tabindex="-1"])';
  let lastFocusedElement = null;

  // Dactylo variables
  const phrases = [
    "Que recherchez-vous ?",
    "Une information ?",
    "Un service ?",
    "Un événement ?"
  ];
  let phraseIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let typeTimer = null;

  if(modal) {
    function typeEffect() {
      const currentPhrase = phrases[phraseIndex];
      let displayText = isDeleting
        ? currentPhrase.substring(0, charIndex--)
        : currentPhrase.substring(0, charIndex++);

      input.setAttribute('placeholder', displayText);

      if (!isDeleting && charIndex === currentPhrase.length + 1) {
        typeTimer = setTimeout(() => { isDeleting = true; typeEffect(); }, 1000);
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        typeTimer = setTimeout(typeEffect, 300);
      } else {
        const speed = isDeleting ? 50 : 100;
        typeTimer = setTimeout(typeEffect, speed);
      }
    }

    function startTyping() {
      phraseIndex = 0;
      charIndex = 0;
      isDeleting = false;
      if (typeTimer) clearTimeout(typeTimer);
      typeEffect();
    }

    function stopTyping() {
      if (typeTimer) clearTimeout(typeTimer);
      input.setAttribute('placeholder', '');
    }

    function openModal(modal, opener) {
      lastFocusedElement = opener.activeElement;
      modal.classList.add('show');
      modal.removeAttribute('hidden');
      document.body.classList.add('no-scroll');
      const firstInput = modal.querySelector('input');
      if (firstInput) firstInput.focus();
      document.addEventListener('keydown', trapFocus);
      startTyping();
    }

    function closeModal() {
      modal.classList.remove('show');
      modal.setAttribute('hidden', 'true');
      document.body.classList.remove('no-scroll');
      stopTyping();
      if (lastFocusedElement) lastFocusedElement.focus();
      document.removeEventListener('keydown', trapFocus);
    }

    function trapFocus(e) {
      const focusables = modal.querySelectorAll(modalFocusableSelectors);
      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal();
      }

      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    openBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const modalId = btn.getAttribute('aria-controls');
        const modal = document.getElementById(modalId);
        openModal(modal, btn); // tu passes la modale ciblée + le bouton pour gérer le focus
      });
    });
    closeBtn.addEventListener('click', closeModal);
  }

  if (document.body.classList.contains('page') && document.querySelector('.editor')) {
    document.querySelectorAll('.editor > p a[target="_blank"]').forEach(link => {
      link.classList.add('external');
    });
    document.querySelectorAll('.editor > ul li a[target="_blank"]').forEach(link => {
      link.classList.add('external');
    });
  }

  if (document.body.classList.contains('single-agenda') || document.body.classList.contains('single-association')) {
    Fancybox.bind("[data-fancybox]", {});
  }

  // Bandeau Alerte
  var alertWrapper = document.getElementById("alerte");
  var closeAlert = alertWrapper ? alertWrapper.querySelector(".close-alert") : null;

  // Clé simple (pas d'ID de post)
  var storageKey = "alertClosed";

  // Si déjà fermé pendant cette visite
  if (sessionStorage.getItem(storageKey) === "true" && alertWrapper) {
      alertWrapper.classList.add("is-hidden");
  }

  // Clic sur le bouton : fermer + mémoriser pour la session
  if (closeAlert && alertWrapper) {
      closeAlert.addEventListener("click", function () {
          alertWrapper.classList.add("is-hidden");
          sessionStorage.setItem(storageKey, "true");
      });
  }
});

("use strict");

class Accordion {
  constructor(domNode) {
    this.rootEl = domNode;
    this.buttonEl = this.rootEl.querySelector(
      "#accordeon button[aria-expanded]"
    );

    const controlsId = this.buttonEl.getAttribute("aria-controls");
    this.contentEl = document.getElementById(controlsId);

    this.open = this.buttonEl.getAttribute("aria-expanded") === "true";

    // add event listeners
    this.buttonEl.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.toggle(!this.open);
  }

  toggle(open) {
    // don't do anything if the open state doesn't change
    if (open === this.open) {
      return;
    }

    // update the internal state
    this.open = open;

    // handle DOM updates
    this.buttonEl.setAttribute("aria-expanded", `${open}`);
    if (open) {
      this.contentEl.removeAttribute("hidden");
    } else {
      this.contentEl.setAttribute("hidden", "");
    }
  }

  // Add public open and close methods for convenience
  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}

// init accordions
const accordions = document.querySelectorAll(".accordion h3");
accordions.forEach((accordionEl) => {
  new Accordion(accordionEl);
});